import { useEffect } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Checkbox, FormControlLabel, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import { useCompanyReducer } from "@/main/store/company";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { KeyValue } from "@/main/models/common";

import * as S from "./styles";

interface ICompanyAllDropdown {
	idScreen: string;
	onChangeCustomCompany?: (value: KeyValue | null) => void;
	onChangeCustomAllCompany?: (value: boolean) => void;
}
function CompanyAllDropdown({
	idScreen,
	onChangeCustomAllCompany = () => {},
	onChangeCustomCompany = () => {},
}: ICompanyAllDropdown) {
	const { control, clearErrors, resetField, setValue } = useFormContext();

	const watcherCompany = useWatch({
		control,
		name: "company",
	});
	const watcherAllCompany = useWatch({
		control,
		name: "allCompany",
	});
	const { companyAll: companyReducer } = useCompanyReducer();

	useEffect(() => {
		if (watcherAllCompany) {
			clearErrors("company");
			resetField("company");
		}
	}, [watcherAllCompany]);

	const generateId = (id: string) => `${idScreen}-${id}`;
	const disabledCompany = watcherAllCompany || isNullUndefined(companyReducer.data) || companyReducer.data.length === 1;
	const isRequiredCompany = !watcherAllCompany;

	return (
		<S.Container $isNullUndefinedValue={isNullUndefined(watcherCompany)}>
			<KogAutoCompleteControlled
				id={generateId("company")}
				nameCustom="company"
				disableClearable={isNullUndefined(watcherCompany)}
				label={getTranslateByKey("information.company")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={companyReducer.data}
				isLoading={companyReducer.isLoading}
				disabled={disabledCompany}
				rulesCustom={{ required: isRequiredCompany }}
				onChangeCustom={(value) => {
					onChangeCustomCompany(value);
				}}
			/>
			{isNullUndefined(watcherCompany) && (
				<Controller
					name="allCompany"
					control={control}
					render={({ field: { onChange, value } }) => (
						<S.AreaCheckbox>
							{!isNullUndefined(watcherCompany) && (
								<IconButton
									className="ClearableIcon"
									onClick={() => {
										if (!isNullUndefined(watcherCompany)) {
											clearErrors("company");
											resetField("company");
											onChangeCustomCompany(null);
										}
									}}
								>
									<ClearIcon fontSize="small" />
								</IconButton>
							)}
							<FormControlLabel
								label={getTranslateByKey("information.generalPriceList")}
								control={
									<Checkbox
										color="primary"
										checked={value}
										onChange={(e) => {
											onChange(e.target.checked);
											onChangeCustomAllCompany(e.target.checked);
										}}
										id={generateId("allCompany")}
									/>
								}
							/>
						</S.AreaCheckbox>
					)}
				/>
			)}
		</S.Container>
	);
}

export default CompanyAllDropdown;
